import { render, staticRenderFns } from "./CustomerFillData.vue?vue&type=template&id=b19b4fe4"
import script from "./CustomerFillData.vue?vue&type=script&lang=js"
export * from "./CustomerFillData.vue?vue&type=script&lang=js"
import style0 from "./CustomerFillData.vue?vue&type=style&index=0&id=b19b4fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports